<template>
  <div id="app" class="wh100">

    <div class="closed fixed wh100 left0 top0 flex-center z999"
         v-if="!isOpen">
      <div>
        Program: 20:00 - 01:00
      </div>
    </div>

    <router-view/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'App',

    computed: {
      ...mapState({
        isOpen: 'isOpen'
      })
    }
  }
</script>

<style lang="less">
  .closed {
    background-color: rgba(0, 0, 0, .9);

    @media only screen and (min-width: 0) {
      div {
        padding: 48px 12px;
        font-size: 3rem;
        border-radius: 4px;
        background-color: white;
        opacity: .8;
      }
    }

    @media only screen and (min-width: 768px) {
    	div {
        padding: 48px 96px;
      }
    }
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
